module.exports = __webpack_public_path__ + "media/images/user-avatar-d5335b4c90820707cdf767a2af28de81.png";